// extracted by mini-css-extract-plugin
var _1 = "FormFields-modulecheckboxLabel__YpUdN";
export { _1 as "checkboxLabel" }
